import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from '../../app.component';
import * as $ from 'jquery';
import { DatePipe } from '@angular/common';
import { OrderPipe } from 'ngx-order-pipe';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'app-badp-guidelines',
    templateUrl: './badp-guidelines.component.html',
    styleUrls: ['./badp-guidelines.component.scss']
})
/** badp-guidelines component*/
export class BadpGuidelinesComponent {
    /** badp-guidelines ctor */
  badpGuidelines: any;
  route: any;
    MenuList: any;
    title: any;
    fileUrl: any;
  itemsPerPage: number;
  Search: any;
  paginationPageNumber: number;
  badpGuidelinesCount: any;
  currentDate: any = new Date();
  modeltitle: any;
  content: any;
  image: any;
  multipleEntry: boolean = false;
  imgUrl: any;
  badpSpinner: boolean;
  constructor(private spinner: NgxSpinnerService,private appComponent: AppComponent, private http: HttpClient, private router: Router, private datePipe: DatePipe, private orderpipe: OrderPipe) {
    this.imgUrl = window["orginalImgUrl"];
    this.fileUrl = window["getfile"];
    var str = this.router.url;
    this.route = str.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');
  }
  ngOnInit() {
    this.paginationPageNumber = 1;
    this.itemsPerPage = 5;
    this.getMenuName();
    this.getBADPGuidelines();
    
  }

  search() {
    this.paginationPageNumber = 1;
  }

  getMenuName() {
    this.spinner.show();
    this.http.get(this.appComponent.APIUrl + 'MenuMaster/', {
    }).subscribe((data: any) => {
      this.MenuList = data.menuMasterDTO.filter(x => x.link == this.route);
      this.title = this.MenuList[0].title;
      this.multipleEntry = this.MenuList[0].multipleEntry;
    });
  }
  getBADPGuidelines() {
    this.badpSpinner = true;
    this.http.get(this.appComponent.APIUrl + 'Post/GetPostByRoute/' + this.route, {
    }).subscribe((data: any) => {
      this.badpSpinner = false;
      this.badpGuidelines = data.postDTO.filter(x => x.status == 'Active' && x.displayonhome == 1);   
      this.badpGuidelinesCount = this.badpGuidelines.length;
      this.currentDate = this.datePipe.transform(this.currentDate, 'yyyy-MM-dd' + 'T00:00:00');
    });
  }
  itemPerPagePagination(event: any) {
    this.itemsPerPage = event.target.value;
  }
}
